<template>
  <sensor-door v-if="valueName == 'sensor_door'" />
  <sensor-window v-else-if="valueName == 'sensor_window'" />
</template>

<script>
import SensorDoor from "@/components/Icons/Home/SensorDoor";
import SensorWindow from "@/components/Icons/Home/SensorWindow";

export default {
  components: {
    SensorDoor,
    SensorWindow,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
